import { Alert } from "@icg360/design-system";

import { ErrorBase } from "./ErrorBase";

export const Error404 = () => {
  return (
    <ErrorBase>
      <Alert
        appearance="warning"
        title="Quote not found."
        description="Nothing could be found matching your request. Check the link you were given. If the problem continues, reach out to your insurance representative."
      />
    </ErrorBase>
  );
};
